import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TouchButton from "../../atoms/TouchButton/TouchButton";
import InputSelect from "../../atoms/InputSelect/InputSelect";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Seventh = ({ formData, setFormData, onValidationChange, mode = 'wizard' }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.identification);
  }, [formData.identification, onValidationChange]);

  if (mode === 'validation') {
    return (
      <InputSelect
        label={t("animalInfo:QUESTION_SEVEN.IDENTIFICATION")}
        datas={[
          { value: "chip", label: t("animalInfo:QUESTION_SEVEN.CHIPED") },
          { value: "tattoo", label: t("animalInfo:QUESTION_SEVEN.TATTOED") },
          { value: "none", label: t("animalInfo:QUESTION_SEVEN.NOT_IDENTIFIED") },
        ]}
        value={formData.identification ?? ""}
        onChange={(event) => setFormData({ ...formData, identification: event.target.value })}
      />
    );
  }

  return (
    <>
      <TouchButton
        text={t("animalInfo:QUESTION_SEVEN.CHIPED")}
        active={formData.identification === "chip"}
        onClick={() => {
          setFormData({ ...formData, identification: "chip" });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_SEVEN.TATTOED")}
        active={formData.identification === "tattoo"}
        onClick={() => {
          setFormData({ ...formData, identification: "tattoo" });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_SEVEN.NOT_IDENTIFIED")}
        active={formData.identification === "none"}
        onClick={() => {
          setFormData({ ...formData, identification: "none" });
        }}
      />
    </>
  );
};

export default Seventh;
